<div id="dimensions-overlay" [style.background]="isDarkTheme ? '#424242' : 'white'" [style.color]="isDarkTheme ? 'white' : 'black'">
  <h3>{{ 'dimensionsOverlay.title' | transloco }}</h3>
  <div class="flex-row text-image-container">
    <div>
      <h4>{{ 'dimensionsOverlay.subtitleFlexible' | transloco }}</h4>
      <p>{{ 'dimensionsOverlay.textFlexible' | transloco }}</p>
      <ul>
        <li>{{ 'dimensionsOverlay.lengthFlexible' | transloco }}</li>
        <li>{{ 'dimensionsOverlay.widthFlexible' | transloco }}</li>
        <li>{{ 'dimensionsOverlay.heightFlexible' | transloco }}</li>
      </ul>
    </div>
    <img class="image" [src]="image2D">
  </div>
  <div class="flex-row text-image-container">
    <img class="image" [src]="image3D">
    <div>
      <h4>{{ 'dimensionsOverlay.subtitleRigid' | transloco }}</h4>
      <p>{{ 'dimensionsOverlay.textRigid' | transloco }}</p>
      <ul>
        <li>{{ 'dimensionsOverlay.lengthRigid' | transloco }}</li>
        <li>{{ 'dimensionsOverlay.widthRigid' | transloco }}</li>
        <li>{{ 'dimensionsOverlay.heightRigid' | transloco }}</li>
      </ul>
    </div>
  </div>
  <div class="flex-row text-image-container">
    <div>
      <h4>{{ 'dimensionsOverlay.subtitleCylindrical' | transloco }}</h4>
      <p>{{ 'dimensionsOverlay.textCylindrical' | transloco }}</p>
      <ul>
        <li>{{ 'dimensionsOverlay.heightCylindrical' | transloco }}</li>
        <li>{{ 'dimensionsOverlay.widthLengthCylindrical' | transloco }}</li>
      </ul>
    </div>
    <img class="image" [src]="imageCylindrical">
  </div>
</div>